import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import { a as DropdownItemGroupDisplayName } from '../displayNames-27272ef3.js';
import { a as DropdownIsMobileConsumer } from '../DropdownIsMobileContext-c2f1e868.js';
import { R as RadioButtonGroup } from '../../RadioGroup/RadioButtonGroup/RadioButtonGroup-872c9154.js';
import { S as SelectOptionGroup } from '../../SelectList/SelectOptionGroup/SelectOptionGroup-0e2bd4d2.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-ea7cc233-62dc80e0.js';

class DropdownItemGroup extends PureComponent {
  render() {
    const {
      label,
      children
    } = this.props;
    return /*#__PURE__*/React__default.createElement(DropdownIsMobileConsumer, null, isMobile => {
      if (isMobile) {
        return /*#__PURE__*/React__default.createElement(RadioButtonGroup, {
          name: "",
          label: label
        }, children);
      }
      return /*#__PURE__*/React__default.createElement(SelectOptionGroup, this.props);
    });
  }
}
_defineProperty(DropdownItemGroup, "displayName", DropdownItemGroupDisplayName);
_defineProperty(DropdownItemGroup, "propTypes", {
  /**
   * Specifies label for the group.
   */
  label: PT.node.isRequired,
  /**
   * Called when the group is clicked.
   */
  onClick: PT.func
});
_defineProperty(DropdownItemGroup, "defaultProps", {
  onClick: noop
});

export { DropdownItemGroup as D };
//# sourceMappingURL=DropdownItemGroup-f18ef1e4.js.map
